// 基础信息----->商品管理，价签管理
const navList = [{
    "id": 11,
    "label": "首页",
    "icon": "icon-jigou",
    "imgUrl": require('@/assets/img/Shou.png'),
    "imgUrlH": require('@/assets/img/ShouH.png'),
    "imgSty": false,
    "show": true,
    "path": "home",

  }, {
    "id": 12,
    "label": "机构管理",
    "icon": "icon-jigou",
    "imgUrl": require('@/assets/img/Ji.png'),
    "imgUrlH": require('@/assets/img/JiH.png'),
    "imgSty": false,
    "show": true,
    "path": "",
  }, {
    "id": 13,
    "label": "商户管理",
    "icon": "icon-jigou",
    "imgUrl": require('@/assets/img/Ji.png'),
    "imgUrlH": require('@/assets/img/JiH.png'),
    "imgSty": false,
    "show": true,
    "path": "",
  }, {
    "id": 14,
    "label": "价签管理",
    "icon": "icon-jigou",
    "imgUrl": require('@/assets/img/Ji.png'),
    "imgUrlH": require('@/assets/img/JiH.png'),
    "imgSty": false,
    "show": true,
    "path": "",
  }

]
export default {
  navList
}



// WEBPACK FOOTER //
// ./src/assets/listData/ListData.js